// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__15L8F","secondary":"Label_secondary__BaHFv","error":"Label_error__v0W9Y"};